import React from 'react';
import { FormattedMessage } from 'react-intl';

function ErrorDescription({ messageId, messageDefault }: { messageId: string; messageDefault: string }) {
  return <FormattedMessage defaultMessage={messageDefault} id={messageId} tagName='p' values={{ br: <br /> }} />;
}

export default ErrorDescription;
